import { ExternalVideoData, ExternalVideoModel } from "../model/external-video-data.model";
import dayjs from "dayjs";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { inject, Injectable } from "@angular/core";
import { ExternalStats, StatType } from "src/app/models/external-stats";
import { Format } from "src/app/models/record";
import { ExternalViewStats, ExternalViewType } from "src/app/models/external-view-stats";

@Injectable({
  providedIn: 'root',
})
export class ExternalVideoDialogFactory {
  private readonly sanitizer = inject(DomSanitizer);

  buildExternalVideoData(externalVideoModel: ExternalVideoModel): ExternalVideoData {
    let link: string | SafeResourceUrl = externalVideoModel.link;

    if (externalVideoModel.format.includes('HTML')) {
      link = this.sanitizer.bypassSecurityTrustResourceUrl(externalVideoModel.link);
    }

    return {
      title: externalVideoModel.title,
      link: link,
      isIframeLink: !!externalVideoModel.format.includes('HTML'),
      optimizeIframeForHTML: !!externalVideoModel.format.includes('HTML'),
      autoHeight: link && !externalVideoModel.link.includes('youtube'),
      isFromExternalDb: externalVideoModel.isFromExternalDb,
    };
  }

  buildExternalStats(externalVideoModel: ExternalVideoModel): ExternalStats {
    const timeOffset = dayjs().utcOffset() / 60;

    return {
      id: undefined,
      type: this.getFormat(externalVideoModel.format),
      resourceId: externalVideoModel.resourceId,
      source: "NgOpac",
      timeZone: timeOffset > 0 ? "+" + timeOffset.toString() : timeOffset.toString(),
      userAgent: window.navigator.userAgent,
      userId: externalVideoModel.userId,
      dateOpen: new Date(),
      dateClose: new Date(),
      checkoutId: externalVideoModel.checkoutId,
    }
  }

  buildExternalViewStats(externalVideoModel: ExternalVideoModel): ExternalViewStats {
    return {
      type: ExternalViewType.YOUTUBE,
      dateOpen: new Date(),
      dateClose: new Date(),
      externalId: externalVideoModel.externalId,
      link: externalVideoModel.directLink,
      searchTerms: externalVideoModel.searchTerms,
    }
  }

  private getFormat(format: Format[]) {
    let statToSend: StatType;

    // This handles resources that are indexed in OTK
    if (format.includes('PODCAST' as Format)) {
      statToSend = StatType.AUDIO;
    } else if (format.includes('PODCAST' as Format)) {
      statToSend = StatType.VIDEO;
    } else if (format.includes('PODCAST' as Format)) {
      statToSend = StatType.TIME_READ_BOOK;
    } else {
      // StatType.AUDIO by default (see ORN-373)
      statToSend = StatType.AUDIO;
    }

    return statToSend;
  }
}
